import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function CSO() {
  return (
    <>
      <div>
        <TableList Role="CSO" />
      </div>
    </>
  );
}
